var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabChange },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "Monthly Credits", name: "monthly" } },
            [
              _vm.lastJobExecution
                ? _c(
                    "el-row",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { gutter: 20 },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "stat-card",
                              attrs: { shadow: "hover" },
                            },
                            [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Last Run"),
                              ]),
                              _c("div", { staticClass: "stat-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(
                                      _vm.lastJobExecution.startedAt
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "stat-sub" },
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          _vm.lastJobExecution.status ===
                                          "success"
                                            ? "success"
                                            : "danger",
                                        size: "mini",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.lastJobExecution.status) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "stat-card",
                              attrs: { shadow: "hover" },
                            },
                            [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Total Users"),
                              ]),
                              _c("div", { staticClass: "stat-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumber(
                                      _vm.lastJobExecution.totalUsers
                                    )
                                  )
                                ),
                              ]),
                              _c("div", { staticClass: "stat-sub" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDuration(
                                      _vm.lastJobExecution.durationMs
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "stat-card",
                              attrs: { shadow: "hover" },
                            },
                            [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Success"),
                              ]),
                              _c(
                                "div",
                                { staticClass: "stat-value stat-success" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(
                                        _vm.lastJobExecution.successCount
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "stat-sub" }, [
                                _vm._v("credits granted"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "stat-card",
                              attrs: { shadow: "hover" },
                            },
                            [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Skipped (0 min)"),
                              ]),
                              _c(
                                "div",
                                { staticClass: "stat-value stat-warning" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(
                                        _vm.lastJobExecution.skippedCount
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "stat-sub" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.lastJobExecution.errorCount > 0
                                      ? _vm.lastJobExecution.errorCount +
                                          " errors"
                                      : "no errors"
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.jobExecutions.length > 0
                ? _c(
                    "el-collapse",
                    { staticStyle: { "margin-bottom": "20px" } },
                    [
                      _c(
                        "el-collapse-item",
                        {
                          attrs: {
                            title: "Job Execution History",
                            name: "jobHistory",
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.jobExecutions,
                                border: "",
                                fit: "",
                                size: "small",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "expand" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          row.resultJson &&
                                          row.resultJson.creditsByCountry
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    padding: "10px 20px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticStyle: {
                                                        margin: "0 0 10px 0",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Credits by Country"
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-table",
                                                    {
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                      attrs: {
                                                        data: _vm.formatCreditsByCountry(
                                                          row.resultJson
                                                            .creditsByCountry
                                                        ),
                                                        border: "",
                                                        size: "mini",
                                                      },
                                                    },
                                                    [
                                                      _c("el-table-column", {
                                                        attrs: {
                                                          prop: "country",
                                                          label: "Country",
                                                          width: "120",
                                                        },
                                                      }),
                                                      _c("el-table-column", {
                                                        attrs: {
                                                          prop: "count",
                                                          label: "Users",
                                                          width: "100",
                                                        },
                                                      }),
                                                      _c("el-table-column", {
                                                        attrs: {
                                                          prop: "seconds",
                                                          label: "Seconds",
                                                          width: "100",
                                                        },
                                                      }),
                                                      _c("el-table-column", {
                                                        attrs: {
                                                          prop: "minutes",
                                                          label: "Minutes",
                                                          width: "100",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          row.resultJson &&
                                          row.resultJson.caneOwnerCount
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    padding: "10px 20px",
                                                  },
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "Cane Owner Bonuses:"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        row.resultJson
                                                          .caneOwnerCount
                                                      ) +
                                                      " users received bonus credits "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          row.errorMessage
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    padding: "10px 20px",
                                                    color: "#F56C6C",
                                                  },
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v("Error:"),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(row.errorMessage) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1005003192
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "Date", width: "160" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(row.startedAt)
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2961395709
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Status",
                                  width: "90",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  row.status === "success"
                                                    ? "success"
                                                    : "danger",
                                                size: "mini",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(row.status) + " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2256783261
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Total",
                                  width: "100",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatNumber(row.totalUsers)
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  372014526
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Success",
                                  width: "100",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatNumber(row.successCount)
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1113739582
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Skipped",
                                  width: "100",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatNumber(row.skippedCount)
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4046943149
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Errors",
                                  width: "90",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              style: {
                                                color:
                                                  row.errorCount > 0
                                                    ? "#F56C6C"
                                                    : "inherit",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(row.errorCount || 0) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  215307977
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Duration",
                                  width: "110",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDuration(row.durationMs)
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3343055747
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.monthlyStats.length > 0
                ? _c(
                    "el-collapse",
                    { staticStyle: { "margin-bottom": "20px" } },
                    [
                      _c(
                        "el-collapse-item",
                        {
                          attrs: {
                            title: "Monthly Grant Statistics",
                            name: "monthlyStats",
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.monthlyStats,
                                border: "",
                                fit: "",
                                size: "small",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "Month", width: "150" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatMonthKey(row.month_key)
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1406539010
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Total Grants",
                                  width: "150",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatNumber(row.total_grants)
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2983638686
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Unique Users",
                                  width: "150",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatNumber(row.unique_users)
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1115460848
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("el-tab-pane", {
            attrs: { label: "Welcome Gift", name: "welcome" },
          }),
        ],
        1
      ),
      _vm.activeTab === "welcome"
        ? _c("el-alert", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              title: "Welcome Gift Configuration",
              type: "success",
              description:
                "Credits given to new users at registration. The phone country code is mapped to ISO country code. If no specific country config exists, the DEFAULT config is used.",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm.activeTab === "monthly"
        ? _c("el-alert", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              title: "Monthly Credits Configuration",
              type: "info",
              description:
                "Configure country-based monthly free credits for users. The 'DEFAULT' configuration applies to users whose country is not specifically listed. Cane Owner Bonus adds extra seconds to users who own an active cane.",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "150px", "margin-right": "10px" },
              attrs: { placeholder: "Status", clearable: "" },
              on: { change: _vm.getList },
              model: {
                value: _vm.listQuery.isActive,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "isActive", $$v)
                },
                expression: "listQuery.isActive",
              },
            },
            [
              _c("el-option", { attrs: { label: "Active", value: true } }),
              _c("el-option", { attrs: { label: "Inactive", value: false } }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { type: "success", icon: "el-icon-plus" },
              on: { click: _vm.handleCreate },
            },
            [_vm._v(" New Country Config ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "ID", width: "70", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(row.id))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Country Code", width: "130", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type:
                            row.countryCode === "DEFAULT"
                              ? "warning"
                              : "primary",
                          size: "small",
                        },
                      },
                      [_vm._v(" " + _vm._s(row.countryCode) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Country Name", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(row.countryName || "-"))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Credits", width: "200", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [
                      _c("strong", [_vm._v(_vm._s(row.creditsSeconds))]),
                      _vm._v(" seconds "),
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: { "font-size": "12px", color: "#909399" },
                      },
                      [
                        _vm._v(
                          " (" +
                            _vm._s(_vm.formatMinutes(row.creditsSeconds)) +
                            ") "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm.activeTab === "monthly"
            ? _c("el-table-column", {
                attrs: {
                  label: "Cane Owner Bonus",
                  width: "250",
                  align: "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          row.caneBonuses && row.caneBonuses.length > 0
                            ? _c(
                                "div",
                                [
                                  _vm._l(row.caneBonuses, function (cb) {
                                    return _c(
                                      "div",
                                      {
                                        key: cb.id,
                                        staticStyle: { "margin-bottom": "2px" },
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            staticStyle: {
                                              "margin-right": "4px",
                                            },
                                            attrs: {
                                              size: "mini",
                                              type: "info",
                                            },
                                          },
                                          [_vm._v(_vm._s(cb.deviceType))]
                                        ),
                                        _c("strong", [
                                          _vm._v("+" + _vm._s(cb.bonusSeconds)),
                                        ]),
                                        _vm._v("s "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "11px",
                                              color: "#909399",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "(" +
                                                _vm._s(
                                                  _vm.formatMinutes(
                                                    cb.bonusSeconds
                                                  )
                                                ) +
                                                ")"
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                  row.caneOwnerBonus > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-top": "4px",
                                            "font-size": "12px",
                                            color: "#909399",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Default: +" +
                                              _vm._s(row.caneOwnerBonus) +
                                              "s "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              )
                            : row.caneOwnerBonus > 0
                            ? _c("div", [
                                _c("strong", [
                                  _vm._v("+" + _vm._s(row.caneOwnerBonus)),
                                ]),
                                _vm._v(" seconds "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "#909399",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " (" +
                                        _vm._s(
                                          _vm.formatMinutes(row.caneOwnerBonus)
                                        ) +
                                        ") "
                                    ),
                                  ]
                                ),
                              ])
                            : _c(
                                "span",
                                { staticStyle: { color: "#C0C4CC" } },
                                [_vm._v("-")]
                              ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2071239952
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { label: "Priority", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-tag", { attrs: { type: "info", size: "small" } }, [
                      _vm._v(_vm._s(row.priority)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Status", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleStatusChange(row)
                        },
                      },
                      model: {
                        value: row.isActive,
                        callback: function ($$v) {
                          _vm.$set(row, "isActive", $$v)
                        },
                        expression: "row.isActive",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Updated At", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(_vm.formatDate(row.updatedAt)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Actions",
              width: "180",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          icon: "el-icon-edit",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row)
                          },
                        },
                      },
                      [_vm._v(" Edit ")]
                    ),
                    row.countryCode !== "DEFAULT"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "danger",
                              icon: "el-icon-delete",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(row)
                              },
                            },
                          },
                          [_vm._v(" Delete ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.dialogStatus === "create"
                ? "Add Country Configuration"
                : "Edit Country Configuration",
            visible: _vm.dialogFormVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "160px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Country Code", prop: "countryCode" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "e.g., TR, US, GB",
                      disabled: _vm.dialogStatus === "update",
                      maxlength: "10",
                    },
                    model: {
                      value: _vm.formData.countryCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "countryCode", $$v)
                      },
                      expression: "formData.countryCode",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        color: "#909399",
                        "margin-top": "5px",
                      },
                    },
                    [
                      _vm._v(
                        " Use ISO 3166-1 alpha-2 codes (e.g., TR, US, GB, DE) or DEFAULT for fallback "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Country Name", prop: "countryName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "e.g., Turkey, United States" },
                    model: {
                      value: _vm.formData.countryName,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "countryName", $$v)
                      },
                      expression: "formData.countryName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "Credits (seconds)", prop: "creditsSeconds" },
                },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: { min: 0, max: 36000, step: 60 },
                    model: {
                      value: _vm.formData.creditsSeconds,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "creditsSeconds", $$v)
                      },
                      expression: "formData.creditsSeconds",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: { "margin-left": "10px", color: "#606266" },
                    },
                    [
                      _vm._v(
                        " = " +
                          _vm._s(
                            _vm.formatMinutes(_vm.formData.creditsSeconds)
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Quick Set" } },
                [
                  _c(
                    "el-button-group",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.setCredits(300)
                            },
                          },
                        },
                        [_vm._v("5 min")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.setCredits(600)
                            },
                          },
                        },
                        [_vm._v("10 min")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.setCredits(900)
                            },
                          },
                        },
                        [_vm._v("15 min")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.setCredits(1800)
                            },
                          },
                        },
                        [_vm._v("30 min")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.setCredits(3600)
                            },
                          },
                        },
                        [_vm._v("60 min")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.activeTab === "monthly"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Default Cane Bonus (s)",
                        prop: "caneOwnerBonus",
                      },
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "200px" },
                        attrs: { min: 0, max: 36000, step: 60 },
                        model: {
                          value: _vm.formData.caneOwnerBonus,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "caneOwnerBonus", $$v)
                          },
                          expression: "formData.caneOwnerBonus",
                        },
                      }),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "10px",
                            color: "#606266",
                          },
                        },
                        [
                          _vm._v(
                            " = " +
                              _vm._s(
                                _vm.formatMinutes(_vm.formData.caneOwnerBonus)
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            color: "#909399",
                            "margin-top": "5px",
                          },
                        },
                        [
                          _vm._v(
                            " Fallback bonus for cane owners without a device-type specific bonus below. "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeTab === "monthly"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Device Type Bonuses" } },
                    [
                      _vm._l(_vm.formData.caneBonuses, function (bonus, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "margin-bottom": "8px",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: {
                                  width: "140px",
                                  "margin-right": "10px",
                                },
                                attrs: { placeholder: "Device Type" },
                                model: {
                                  value: bonus.deviceType,
                                  callback: function ($$v) {
                                    _vm.$set(bonus, "deviceType", $$v)
                                  },
                                  expression: "bonus.deviceType",
                                },
                              },
                              _vm._l(
                                _vm.availableDeviceTypes(index),
                                function (dt) {
                                  return _c("el-option", {
                                    key: dt,
                                    attrs: { label: dt, value: dt },
                                  })
                                }
                              ),
                              1
                            ),
                            _c("el-input-number", {
                              staticStyle: { width: "160px" },
                              attrs: { min: 0, max: 36000, step: 60 },
                              model: {
                                value: bonus.bonusSeconds,
                                callback: function ($$v) {
                                  _vm.$set(bonus, "bonusSeconds", $$v)
                                },
                                expression: "bonus.bonusSeconds",
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "margin-left": "8px",
                                  "margin-right": "12px",
                                  color: "#606266",
                                  "font-size": "13px",
                                },
                              },
                              [
                                _vm._v(
                                  " = " +
                                    _vm._s(
                                      _vm.formatMinutes(bonus.bonusSeconds)
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("el-button", {
                              attrs: {
                                type: "danger",
                                icon: "el-icon-delete",
                                size: "mini",
                                circle: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.removeCaneBonus(index)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            icon: "el-icon-plus",
                            size: "small",
                            plain: "",
                            disabled:
                              _vm.formData.caneBonuses.length >=
                              _vm.deviceTypes.length,
                          },
                          on: { click: _vm.addCaneBonus },
                        },
                        [_vm._v(" Add Device Bonus ")]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            color: "#909399",
                            "margin-top": "5px",
                          },
                        },
                        [
                          _vm._v(
                            " Set different bonus seconds per device type. If a device type is not listed, the default bonus above is used. "
                          ),
                        ]
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "Priority", prop: "priority" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: { min: 0, max: 100 },
                    model: {
                      value: _vm.formData.priority,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "priority", $$v)
                      },
                      expression: "formData.priority",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        color: "#909399",
                        "margin-top": "5px",
                      },
                    },
                    [
                      _vm._v(
                        " Higher priority takes precedence. DEFAULT should have priority 0. "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Active" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.formData.isActive,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "isActive", $$v)
                      },
                      expression: "formData.isActive",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitForm },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.dialogStatus === "create" ? "Create" : "Save"
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }